window.EVASuit = window.EVASuit || {};
window.EVASuit.Behaviors = window.EVASuit.Behaviors || {};

window.EVASuit.Behaviors.ElementMissingError = function() {
    "use strict";

    /**
     * Error that indicates that a required element is invalid or missing.
     */
    class ElementMissingError extends Error {
        constructor(message) {
            super(message);
            this.name = "ElementMissingError";
        }
    }

    return ElementMissingError;
}();